export const BASEROW_CONFIG = {
  BASE_URL: 'https://baserow.azizhub.com/api/database',
  TABLE_ID: import.meta.env.VITE_BASEROW_TABLE_ID || '602',
  TOKEN: import.meta.env.VITE_BASEROW_API_TOKEN,
  FIELDS: {
    MCQID: '5123',
    QUESTION: '5127',
    OPTION_A: '5128',
    OPTION_B: '5129',
    OPTION_C: '5130',
    OPTION_D: '5131',
    ANSWER: '5125',
    TOPIC: '5132',
    SUBTOPIC: '5157',
    DUPLICATE: '5183',
    COMPARED: '5188',
    FULL_MCQ: '5156',
    TAGS: '7978',
    TO_REVIEW: '5187'
  }
};

export function getBaserowHeaders(): Record<string, string> {
  if (!BASEROW_CONFIG.TOKEN) {
    throw new Error('Baserow API token is not configured');
  }

  return {
    'Authorization': `Token ${BASEROW_CONFIG.TOKEN}`,
    'Content-Type': 'application/json'
  };
}